
import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Switch, Grid, IconButton, TextField, Tooltip, FormControlLabel, Checkbox, Typography, Icon } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import {
  panelsActiveItem,
  panelsRemoveActiveItem,
  panelsRemoveActiveItemById,
  panelsRemoveActive
} from '../../../../../reducers/panels/panelsReducer';
import { CustomTable } from '../../../../common/Tables/CustomTable/CustomTable';
import { PanelsOptionsMenu } from '../../../Options/PanelsOptionsMenu/PanelsOptionsMenu';
import { dateFormat } from '../../../../../helpers/dataFormatters';
import { ViewColumn } from '@mui/icons-material';
import { InventoryColumnSelector } from '../../../../Inventory/InventoryColumnSelector/InventoryColumnSelector';

export const PanelsList = ({ data, columns }) => {
  //las columnas que se ven por defecto
  const [visibleColumnIds, setVisibleColumnIds] = useState(['select', 'id', 'name', 'ip', 'firmware_version', 'serial_number_ucc', 'last_download', 'status_flag', 'alarm_send', 'on_off_schedule_send', 'counter_address', 'deleteAndSummary']);
  const displayedColumns = columns.filter(column => visibleColumnIds.includes(column.id));

  const [search, setSearch] = useState('');
  const activeItem = useSelector(state => state.panels.active);
  const dispatch = useDispatch();
  const totalItems = useSelector(state => state.panels.panels)
  const handleSelect = (panelId, isChecked) => {
    if (isChecked) {
      dispatch(panelsActiveItem({ id: panelId }));
    } else {
      dispatch(panelsRemoveActiveItemById(panelId));
    }
  };

  const handleUnSelectAll = () => {
    dispatch(panelsRemoveActive([]));
    dispatch(panelsRemoveActiveItem([]));
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      filteredData.forEach(panel => {
        if (!activeItem.some(item => item.id === panel.id)) {
          dispatch(panelsActiveItem({ id: panel.id }));
        }
      });
    } else {
      dispatch(panelsRemoveActiveItem());
    }
  };


  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  // Función personalizada para copiar datos (opcional - puedes usar la por defecto)
  const handleCopySelectedData = (selectedData) => {
    // Obtener los IDs de los paneles seleccionados
    const selectedIds = selectedData.map(row => row.id);

    // Filtrar los datos originales basados en los IDs seleccionados
    const originalSelectedData = data.filter(item =>
      selectedIds.includes(item.id)
    );

    // Formatear como prefieras
    const dataToCopy = originalSelectedData.map(item => {
      return columns
        .filter(column =>
          column.id !== 'select' &&
          column.id !== 'deleteAndSummary'
        )
        .map(column => {
          const value = item[column.id];
          return value ? String(value) : '';
        })
        .join('\t');
    }).join('\n');

    navigator.clipboard.writeText(dataToCopy)
      .then(() => console.log('Datos de paneles copiados al portapapeles'))
      .catch(err => console.error('Error al copiar datos: ', err));
  };

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      search.length === 0
        ? true
        : columns.some((column) => {
          const value = row[column.id];
          return value && String(value).toLowerCase().includes(search.toLowerCase());
        })
    );
  }, [data, search, columns]);

  const allSelected = useMemo(() => {
    return filteredData.length > 0 && filteredData.every(panel => activeItem.some(item => item.id === panel.id));
  }, [filteredData, activeItem]);

  return (
    <Grid container className='animate__animated animate__fadeIn animate__fast'>
      <Grid item sm={5}>
        <TextField
          id="search"
          label="Buscar"
          type="search"
          name="search"
          autoComplete="off"
          value={search}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>

      <Grid item sm={2}>
        <Tooltip title="Eliminar todo">
          <IconButton edge="end" aria-label="delete" onClick={handleUnSelectAll}>
            <DeleteSweepIcon style={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item sm={3} style={{ marginTop: '25px' }} >
        <Typography variant='h6'>
          <strong>{activeItem.length}</strong> / {totalItems.length} CM seleccionados
        </Typography>
      </Grid>
      <Grid item sm={2} style={{ marginTop: '25px' }}>
        <InventoryColumnSelector columns={columns} visibleColumns={visibleColumnIds} onChange={setVisibleColumnIds} columnsIgnored={['select', 'deleteAndSummary']} />
      </Grid>
      <Grid item sm={6} style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Switch
              checked={allSelected}
              onChange={(event) => handleSelectAll(event.target.checked)}
              color="primary"
            />
          }
          label="Marcar/Desmarcar todos"
        />
      </Grid>
      <Grid item style={{ width: '100%', marginTop: '16px' }}>
        <CustomTable
          rows={filteredData.map((panel) => {
            const isSelected = activeItem.some(item => item.id === panel.id);

            const formatted = { ...panel };

            columns.forEach(col => {
              if (col?.id in formatted) {
                formatted[col.id] = dateFormat(formatted[col.id]);
              }
            });

            return {
              ...formatted,
              select: (
                <Checkbox
                  checked={isSelected}
                  onChange={(event) => handleSelect(panel.id, event.target.checked)}
                  onClick={(e) => e.stopPropagation()} // Para que no dispare el click de la fila
                />
              ),
              deleteAndSummary: (
                <div onClick={(e) => e.stopPropagation()}>
                  <PanelsOptionsMenu id={panel.id} />
                </div>
              ),
              _onClick: () => handleSelect(panel.id, !isSelected),
            };
          })}
          columns={displayedColumns}
          enableCopy={true} // Habilitar la funcionalidad de copiar
        />
      </Grid>
    </Grid>
  );
};

PanelsList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};




/*
import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Switch, Grid, IconButton, TextField, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import PropTypes from 'prop-types';
import {
  panelsActiveItem,
  panelsRemoveActiveItem,
  panelsRemoveActiveItemById,
  panelsRemoveActive
} from '../../../../../reducers/panels/panelsReducer';
import { CustomTable } from '../../../../common/Tables/CustomTable/CustomTable';
import { PanelsOptionsMenu } from '../../../Options/PanelsOptionsMenu/PanelsOptionsMenu';

export const PanelsList = ({ data, columns }) => {
  const [search, setSearch] = useState('');
  const activeItem = useSelector(state => state.panels.active);
  const dispatch = useDispatch();

  const handleSelect = (panelId, isChecked) => {
    if (isChecked) {
      dispatch(panelsActiveItem({ id: panelId }));
    } else {
      dispatch(panelsRemoveActiveItemById(panelId));
    }
  };

  const handleUnSelectAll = () => {
    dispatch(panelsRemoveActive([]));
    dispatch(panelsRemoveActiveItem([]));
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      filteredData.forEach(panel => {
        if (!activeItem.some(item => item.id === panel.id)) {
          dispatch(panelsActiveItem({ id: panel.id }));
        }
      });
    } else {
      dispatch(panelsRemoveActiveItem());
    }
  };


  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };


  const filteredData = useMemo(() => {
    return data.filter((row) =>
      search.length === 0
        ? true
        : columns.some((column) => {
          const value = row[column.id];
          return value && String(value).toLowerCase().includes(search.toLowerCase());
        })
    );
  }, [data, search, columns]);

  const allSelected = useMemo(() => {
    return filteredData.length > 0 && filteredData.every(panel => activeItem.some(item => item.id === panel.id));
  }, [filteredData, activeItem]);

  return (
    <Grid container className='animate__animated animate__fadeIn animate__fast'>
      <Grid item sm={5}>
        <TextField
          id="search"
          label="Buscar"
          type="search"
          name="search"
          autoComplete="off"
          value={search}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>

      <Grid item sm={2}>
        <Tooltip title="Eliminar todo">
          <IconButton edge="end" aria-label="delete" onClick={handleUnSelectAll}>
            <DeleteSweepIcon style={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item sm={12} style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Switch
              checked={allSelected}
              onChange={(event) => handleSelectAll(event.target.checked)}
              color="primary"
            />
          }
          label="Marcar/Desmarcar todos"
        />
      </Grid>

      <Grid item style={{ width: '100%', marginTop: '16px' }}>
        <CustomTable
          rows={filteredData.map((panel) => {
            const isSelected = activeItem.some(item => item.id === panel.id);
            return {
              ...panel,
              select: (
                <Checkbox
                  checked={isSelected}
                  onChange={(event) => handleSelect(panel.id, event.target.checked)}
                  onClick={(e) => e.stopPropagation()} // Para que no dispare el click de la fila
                />
              ),
              deleteAndSummary: (
                <div onClick={(e) => e.stopPropagation()}>
                  <PanelsOptionsMenu id={panel.id} />
                </div>
              ), 
              _onClick: () => handleSelect(panel.id, !isSelected),
            };
          })}
          columns={columns}
        />
      </Grid>
    </Grid>
  );
};

PanelsList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};
*/